module.exports = __webpack_public_path__ + "static/media/1.7916cc0e.jpg";